import { render, staticRenderFns } from "./ph-add.vue?vue&type=template&id=71991a17&scoped=true"
import script from "./ph-add.vue?vue&type=script&lang=js"
export * from "./ph-add.vue?vue&type=script&lang=js"
import style0 from "./ph-add.vue?vue&type=style&index=0&id=71991a17&prod&scoped=true&lang=css"
import style1 from "./ph-add.vue?vue&type=style&index=1&id=71991a17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71991a17",
  null
  
)

export default component.exports